export function requestIdleCallbackSafe(fn, ms = 100) {
    if (typeof (window === null || window === void 0 ? void 0 : window.requestIdleCallback) === "function") {
        return window.requestIdleCallback(fn, { timeout: ms });
    }
    else {
        return setTimeout(() => {
            const deadline = {
                didTimeout: false,
                timeRemaining: () => Math.max(0, ms - Date.now()),
            };
            fn(deadline);
        }, ms);
    }
}
